import React, { memo } from 'react'
import { IDriver } from 'apps/fleet-planner/types'
import { Avatar } from 'transfix-ui'

interface IDriverName {
  driver: IDriver
}

export const DriverName = memo<IDriverName>(({ driver }) => (
  <div className='pl6 row'>
    <div className='flex items-center'>
      <div className='mr2'>
        <Avatar key={driver?.name} name={driver?.name} />
      </div>
      <div>{driver?.name}</div>
    </div>
  </div>
))
